import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function getSuarteInvoices() {
  return fetchWrapper.get(`${config.apis.api.url}/invoices`, { injectToken: true });
}

function getGalleryInvoices() {
  return fetchWrapper.get(`${config.apis.api.url}/api/collector-invoices`, { injectToken: true });
}

function requestSuarteInvoice({ orderId = null, orderNumber = null } = {}) {
  return fetchWrapper.post(`${config.apis.api.url}/invoices/request-now/`, {
    injectToken: true,
    body: { order_id: orderId, order_number: orderNumber },
  });
}

function requestGalleryInvoice({ orderId = null, orderNumber = null } = {}) {
  return fetchWrapper.post(`${config.apis.api.url}/api/gallery-created-invoices/request`, {
    injectToken: true,
    body: { order_id: orderId, order_number: orderNumber },
  });
}

const invoicesService = {
  getSuarteInvoices,
  getGalleryInvoices,
  requestSuarteInvoice,
  requestGalleryInvoice,
};

export default invoicesService;
